module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_6005.1dc403db.png";